import {useEffect, useState} from 'react';
import SidebarButton from "./SidebarButton";
import { Logout, WhiteAccount, SmallLetter, Delete, BigLetter, Account } from '../../../ui/icons';
import Modal from './Modal';
import {useDispatch, useSelector} from "react-redux";
import {registerLogout} from "../../../store/formSlice";
import {useNavigate} from "react-router-dom";
import {logout} from "../../../store/authSlice"; // Подключаем модалку

const ProfileSidebar = ({ activeTab, setActiveTab }) => {
    const [showModal, setShowModal] = useState(false); // Состояние для показа модалки
    const [modalMessage, setModalMessage] = useState(''); // Сообщение для модалки
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { token } = useSelector(state => state.auth);
    const { token: registerToken } = useSelector(state => state.form);    // Функция для открытия модалки с сообщением
    const {user} = useSelector((store) => store.auth)

    const openModal = (message) => {
        setModalMessage(message);
        setShowModal(true);
    };
    useEffect(() => {
        if(!token && !registerToken){
            navigate("/signin");
        }
    }, [token,registerToken]);
    const closeModal = () => {
        setShowModal(false);
        setModalMessage('');
    };

    const handleConfirm = () => {
        closeModal();
    };
    const logOut = () => {
        dispatch(logout());
        dispatch(registerLogout())
        navigate("/signin")
    }
    return (
        <div className='flex flex-col bg-[#FFFFFF] px-5 py-6 md:w-1/4 text-center items-center rounded-xl'>
            <p className='pb-5 text-xl'>Personal details</p>
            <img src={`${user?.photo ? user?.photo : "./images/Profile/beg.png"}`} className='w-1/3 rounded-[50%]' alt="Profile" />
            <h2 className='font-semibold text-xl'>{user?.first_name} {user?.last_name}</h2>
            <p className='flex text-[13px] gap-1 items-center'><SmallLetter /> {user?.email}</p>
            <div className='flex flex-col w-full gap-2 pt-4'>
                <SidebarButton active={activeTab === 'personalData'} onClick={() => setActiveTab('personalData')} icon={activeTab === 'personalData' ? <WhiteAccount /> : <Account />} text='Personal data' />
                <SidebarButton active={activeTab === 'accountSecurity'} onClick={() => setActiveTab('accountSecurity')} icon={<BigLetter />} text='Account Security' />
                <SidebarButton onClick={logOut}icon={<Logout />} text='Log out' />
                <SidebarButton onClick={() => openModal('Are you sure you want to delete your account?')} icon={<Delete />} text='Delete account' textColor='#D40000' borderColor='#D40000' />
            </div>

            {/*<Modal*/}
            {/*    message={modalMessage}*/}
            {/*    onClose={closeModal}*/}
            {/*    onConfirm={handleConfirm}*/}
            {/*    show={showModal}*/}
            {/*/>*/}
        </div>
    );
};

export default ProfileSidebar;
